import React from 'react';

interface MiniColumnHeaderProps {
  title: string;
  trailing?: React.ReactNode;
}

export function MiniColumnHeader({ title, trailing }: MiniColumnHeaderProps) {
  return (
    <div className="px-2 py-1.5 border-b border-border-subtle bg-surface-panel flex items-center justify-between shrink-0">
      <span className="text-[8px] font-[var(--fw-medium)] text-text-secondary">{title}</span>
      {trailing}
    </div>
  );
}
